/**
 * 인증 훅
 * AuthContext를 통해 인증 상태와 액션에 접근합니다.
 */

import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import type { AuthContextValue } from "../context/AuthContext";

/**
 * 인증 상태와 액션을 제공하는 훅
 * @throws AuthProvider 외부에서 호출 시 에러 발생
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
}
